// ** React Basics Imports
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
// ** Reactstrap Imports
import { Row, Col, Button, Alert, Spinner } from "reactstrap"
// ** Components
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import WizardVertical from "./WizardVertical"
import { AlertOctagon, RefreshCcw, XSquare } from "react-feather"
// ** Timeline Data
import BasicTimeline from "./timeline/BasicTimeline"
// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import { resetFormAndPersonData, getPerson } from "@store/stores/person"
// ** Utils
import { dateISO } from "@lib/util"

const Visits = () => {
  // ** Vars and Hooks
  const personStore = useSelector((state) => state.persons)
  const userStore = useSelector((state) => state.users)
  // const wizardIsLinear = !store.selectedPerson?.id
  //** Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const MySwal = withReactContent(Swal)

  // ** Functoins
  const resetForm = () => {
    const resetUrlRedirect =
      params.personId && params.action === "Validate" ? "/CRM/PersonsToValidate" : "/CRM"
    MySwal.fire({
      icon: "warning",
      title: "Warning",
      text: "Your modifications will be lost. Are you sure?",
      customClass: { confirmButton: "btn btn-warning mx-1", cancelButton: "btn btn-light ms-1" },
      showCancelButton: true,
      confirmButtonText: "Abandon",
      cancelButtonText: "Stay"
    }).then(function (result) {
      if (result.isConfirmed) {
        dispatch(resetFormAndPersonData())
        navigate(resetUrlRedirect)
      }
    })
  }

  // ** useEffect
  useEffect(() => {
    // clean up store to avoid data mismatch
    dispatch(resetFormAndPersonData())
    // get the fresh person data
    if (params.personId) dispatch(getPerson(parseInt(params.personId)))
  }, [dispatch, params.personId])

  // ** Adding a person
  if (!personStore.selectedPerson && params.personId) {
    return (
      <Row>
        <Col sm="4" className="mx-auto text-center">
          <Spinner color="primary" />
        </Col>
      </Row>
    )
  }

  // ** Viewing a person without interaction
  if (personStore.selectedPerson && !personStore.selectedPerson?.interaction) {
    return (
      <Row>
        <Col sm="4" className="mx-auto my-3">
          <Alert color="warning" className="d-flex p-2">
            <AlertOctagon size={17} />
            <div className="ms-2">
              <p>No interaction found for Person (ID {personStore.selectedPerson?.id})</p>
              <small>
                <Button type="button" color="info" outline onClick={() => navigate(0)}>
                  <RefreshCcw size={14} className="align-middle me-sm-25 me-0" />
                  <span className="align-middle d-sm-inline-block">Refresh</span>
                </Button>
                <span className="ms-75">this page and try again.</span>
              </small>
            </div>
          </Alert>
        </Col>
      </Row>
    )
  }

  // ** Normal render
  return (
    <>
      <Button type="button" color="light" onClick={resetForm}>
        <XSquare size={14} className="align-middle me-sm-25 me-0" />
        <span className="align-middle d-sm-inline-block">Return</span>
      </Button>
      <Row>
        {((params.personId && personStore.selectedPerson) ||
          (!params.personId && !personStore.selectedPerson)) && (
          <Col>
            <WizardVertical linear />
            {personStore.selectedPerson?.createdOn && (
              <p className="text-muted small text-end">
                Created {dateISO(personStore.selectedPerson.createdOn, true, true)}
                <br />
                Updated {dateISO(personStore.selectedPerson.updatedOn, true, true)}
              </p>
            )}
          </Col>
        )}
        {personStore.selectedPerson && (
          <Col sm="4">
            <BasicTimeline
              personId={personStore.selectedPerson.id}
              isAdminCRM={userStore.selectedUser?.roles?.CRM_Admin}
            />
          </Col>
        )}
      </Row>
    </>
  )
}
export default Visits
